

















import LoadingPage from '@/components/loading/LoadingPage.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import {Loading, LoadingInitState} from '@/store/loading/loading.types';
import {AuthEnum} from './store/auth/auth.enum';
import {Toast, ToastInitState} from '@/store/toast/toast.types';


@Component({
  components: {
    LoadingPage,
  },
})
export default class AppComponent extends Vue {
  @State('loading') loadingInitState!: LoadingInitState;
  @State('toast') toastInitState!: ToastInitState;

  public loading = {loading: true} as Loading;

  @Watch('toastInitState.toast')
  onToastChanged(toast: Toast) {
    this.forToast(toast)
  }


  async mounted() {
    this.loading = this.loadingInitState.Load;
    console.log(this.loading.loading)
  }

  async forToast({message, heading, type}: { message: string, heading: string, type: string }) {
    this.$bvToast.toast(message, {
      title: heading,
      variant: type,
      autoHideDelay: 5000,
      appendToast: true
    })
  }


}
